export const RUNTIME_SERVER_URL_KEY = 'al_server_url';

function safeString(v: unknown): string {
  if (v == null) return '';
  if (typeof v === 'string') return v;
  try {
    return String(v);
  } catch {
    return '';
  }
}

export function normalizeServerUrl(raw: unknown): string {
  const s = safeString(raw).trim();
  if (!s) return '';
  try {
    const u = new URL(s);
    if (u.protocol !== 'http:' && u.protocol !== 'https:') return '';
    u.hash = '';
    u.search = '';
    u.username = '';
    u.password = '';
    u.pathname = '';
    return `${u.protocol}//${u.host}`.replace(/\/$/, '');
  } catch {
    return '';
  }
}

export function getRuntimeServerUrl(): string {
  try {
    return safeString(localStorage.getItem(RUNTIME_SERVER_URL_KEY)).trim();
  } catch {
    return '';
  }
}

export function setRuntimeServerUrl(raw: unknown): string {
  const serverUrl = normalizeServerUrl(raw);
  try {
    if (serverUrl) localStorage.setItem(RUNTIME_SERVER_URL_KEY, serverUrl);
    else localStorage.removeItem(RUNTIME_SERVER_URL_KEY);
  } catch {}
  return serverUrl;
}

export function isNativeShell(): boolean {
  try {
    if (typeof window === 'undefined') return false;
    const cap: any = (window as any).Capacitor;
    if (cap) {
      try {
        if (typeof cap.isNativePlatform === 'function') {
          if (cap.isNativePlatform()) return true;
        }
      } catch {}
      try {
        if (typeof cap.getPlatform === 'function') {
          const p = String(cap.getPlatform() || '').toLowerCase();
          if (p && p !== 'web') return true;
        }
      } catch {}
    }
    const proto = String(window.location?.protocol || '').toLowerCase();
    if (proto === 'capacitor:' || proto === 'ionic:') return true;
    return false;
  } catch {
    return false;
  }
}

export function buildServerUrl(pathOrUrl: string): string {
  const raw = String(pathOrUrl || '').trim();
  if (!raw) return raw;
  if (raw.startsWith('http://') || raw.startsWith('https://')) return raw;
  if (!isNativeShell()) return raw;
  const serverUrl = getRuntimeServerUrl();
  if (!serverUrl) return raw;
  if (raw.startsWith('/')) return `${serverUrl}${raw}`;
  return `${serverUrl}/${raw}`;
}
